<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
    <div *ngFor="let notification of notifications; trackBy: trackByFn" class="toast show"
        [class]="getNotificationClass(notification.type)" role="alert" aria-live="assertive" aria-atomic="true"
        (click)="onNotificationClick(notification)" style="cursor: pointer;">

        <div class="toast-header">
            <strong class="me-auto">{{ notification.title }}</strong>
            <button type="button" class="btn-close"
                (click)="removeNotification(notification.id); $event.stopPropagation()" aria-label="Close">
            </button>
        </div>

        <div class="toast-body">
            {{ notification.message }}
            <div *ngIf="notification.data?.service_id || notification.data?.maintenance_id" class="mt-2">
                <small class="text-muted">
                    <span *ngIf="notification.data?.service_id">Servicio #{{ notification.data.service_id }}</span>
                    <span *ngIf="notification.data?.maintenance_id">Mantenimiento #{{ notification.data.maintenance_id
                        }}</span>
                    <span *ngIf="notification.data?.new_status"> - {{ notification.data.new_status }}</span>
                </small>
            </div>
        </div>
    </div>
</div>

<!-- WebSocket Connection Status -->
<div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1050;">
    <div class="toast show" *ngIf="!(websocketService.getConnectionStatus() | async)" role="alert">
        <div class="toast-header bg-warning">
            <strong class="me-auto">Conexión</strong>
            <button type="button" class="btn-close" (click)="websocketService.reconnect()" aria-label="Reconectar">
            </button>
        </div>
        <div class="toast-body">
            Sin conexión en tiempo real.
            <button class="btn btn-sm btn-outline-primary ms-2" (click)="websocketService.reconnect()">
                Reconectar
            </button>
        </div>
    </div>
</div>